export default __webpack_public_path__ + "static/media/Insight.ec8eed8df3d066da12d63c6946823292.svg";